import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import logo from '../imgs/logo.svg';

// Dynamically import all certification logos
const certificationLogos = require.context('../assets/certifications', false, /\.(png|jpe?g|svg)$/);
const certificationImages = certificationLogos.keys().map(key => ({
  src: certificationLogos(key),
  name: key.replace('./', '').replace(/\.(png|jpe?g|svg)$/, '')
}));

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-logo">
            <img src={logo} alt="OneAligned logo" width="100" height="100" />
          </div>

          <div className="footer-contact">
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <span>PO box 21 St Leonard MD 20685</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <span>(252) 241-4567</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">✉️</span>
              <a href="mailto:connect@onealigned.com" className="contact-email">connect@onealigned.com</a>
            </div>
          </div>

          <div className="footer-social">
            <a href="https://www.linkedin.com/company/one-aligned-inc/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
              <span className="linkedin-text">Linked</span>
              <span className="linkedin-box">in</span>
            </a>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <div className="footer-links">
            <Link to="/about" className="footer-link">ABOUT US</Link>
            <Link to="/contact" className="footer-link">CONTACT US</Link>
            <Link to="/careers" className="footer-link">CAREERS</Link>
            <Link to="/services" className="footer-link">SERVICES</Link>
            <Link to="/strategy" className="footer-link">ALIGN</Link>
            <Link to="/employee-portal" className="footer-link">EMPLOYEE PORTAL</Link>
            <Link to="/privacy-policy" className="footer-link">PRIVACY POLICY</Link>
            <Link to="/terms-of-use" className="footer-link">TERMS OF USE</Link>
          </div>
          
          <div className="footer-certifications">
            {certificationImages.map((certification, index) => (
              <div key={index} className="footer-cert-item">
                <img src={certification.src} alt={certification.name} className="footer-cert-logo" />
              </div>
            ))}
          </div>

          <div className="footer-copyright">
            <p>Copyright {new Date().getFullYear()} | One Aligned Inc.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
